import { api } from '@/helpers/interceptors'
import { GET_STOCK_LIST, GET_STOCK_DETAIL } from '@/constants/path'
import moment from 'moment'

const initialMeta = {
  total_item_current_page: 20,
  item_per_page: 20,
  current_page: 1,
  total_page: null,
}

const state = () => ({
  stockList: null,
  stockListUpdateAt: null,
  stockDetail: null,
  stockDetailUpdateAt: null,
  selectSku: null,
  stockListMeta: initialMeta,
  isToast: false,
  isError: false,
  isLoading: false,
})

// getters
const getters = {}

// actions
const actions = {
  async getStockList({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
      if (payload) {
        const params = {
          sku: payload?.sku?.trim() || undefined,
          name: payload?.name?.trim() || undefined,
          page: payload?.page || 1,
        }
        const res = await api(GET_STOCK_LIST, 'get', { params })

        commit('SET_STOCK_LIST', res?.data?.data)
        commit('SET_STOCK_LIST_META', res?.data?.meta)
        commit('SET_LOADING', false)
      } else {
        const res = await api(GET_STOCK_LIST, 'get')

        commit('SET_STOCK_LIST', res?.data?.data)
        commit('SET_STOCK_LIST_META', res?.data?.meta)
        commit('SET_LOADING', false)
      }
    } catch (error) {
      commit('SET_STOCK_LIST', null)
      commit('SET_STOCK_LIST_META', initialMeta)
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },

  async getStockDetail({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
      const params = {
        sku: payload?.sku?.trim() || undefined,
        name: payload?.name?.trim() || undefined,
      }

      const res = await api(GET_STOCK_DETAIL, 'get', { params })

      commit('SET_STOCK_DETAIL', res?.data?.data)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_STOCK_DETAIL', null)
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
}

// mutations
const mutations = {
  SET_STOCK_LIST(state, payload) {
    state.stockList = payload
    state.stockListUpdateAt = moment().format('YYYY-MM-DD HH:mm:ss')
  },
  SET_STOCK_LIST_META(state, payload) {
    state.stockListMeta = payload
  },
  SET_STOCK_DETAIL(state, payload) {
    state.stockDetail = payload
    state.stockDetailUpdateAt = moment().format('YYYY-MM-DD HH:mm:ss')
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_TOAST(state, payload) {
    state.isToast = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
